import React from 'react';
import { useEffect } from 'react';

import Navigation from '../components/layout/nav';
import './map.css';
import Header from '../components/layout/header';
import Button from '../components/common/button';
import HeadingBlock from '../components/common/heading';
const Map = () => {
     useEffect(() => {
        const originalColor = window.getComputedStyle(document.body).backgroundColor;
        document.body.style.setProperty('background-color', '#FFF4E2', 'important');
    
        return () => {
          document.body.style.removeProperty('background-color');
          document.body.style.backgroundColor = originalColor;
        };
      }, []);
    return ( <>
        <Header class="fixedWidth" heading="Map" subheading="Find Us here!" style1="dark left decor"/>
    
      <main>

        <section className='sectionPadded'>
        <HeadingBlock heading="Carrefour City Center Almaza" subheading="Find Us here! View our location on the map." style1="dark left "/>

            <div className='firstMap' >
          <iframe
            title="Cairo International Convention Center map"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://api.maptiler.com/maps/019df96b-e0f5-7537-8811-d6714c320023/?key=HKdyafVjoQHYZLyJTsL0#12.2/30.12750/31.60414"
          >
            <a href="https://www.mapsdirections.info/pl/mapa-populacji/">Check Location</a>
          </iframe>
        </div>
        
        <Button
        cta="Navigate me there"
        link="https://maps.app.goo.gl/SFErnvogCERWhazJ8"
        style1="blue size1 "
        />
        </section>
      </main>
      <Navigation />
    </> );
}
 
export default Map;